import React from "react";
import { useFieldArray } from "react-hook-form";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import "../constants/constants.css";
import "./Previews.css";

export default function Fields({ control, register }) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "previews",
  });

  return (
    <div className="form-wrapper">
      <ul className="outer-input-preview-form-container">
        {fields.map((item, index) => {
          return (
            <li key={item.id}>
              <div className="input-container">
                <div className="inner-input-preview-form-container">
                  <InputFieldFormArray
                    label="Preview name"
                    fieldRef={register(`previews[${index}].type`, {
                      required: false,
                    })}
                    name={`previews[${index}].type`}
                    key={item.id}
                  />

                  <InputFieldFormArray
                    label="Preview link"
                    fieldRef={register(`previews[${index}].link`, {
                      required: false,
                    })}
                    name={`previews[${index}].link`}
                    key={item.id + 1}
                  />

                  <InputFieldFormArray
                    label="Preview qr link"
                    fieldRef={register(`previews[${index}].qr`, {
                      required: false,
                    })}
                    name={`previews[${index}].qr`}
                    key={item.id + 2}
                  />
                  <button
                    className="delete-preview-button"
                    type="button"
                    onClick={() => {
                      remove(index);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </li>
          );
        })}
      </ul>

      <section>
        <button
          className="append-button"
          type="button"
          onClick={() => {
            append();
          }}
        >
          Add Previews
        </button>
      </section>
    </div>
  );
}
